<section class="h-100 gradient-custom">
  <link href='https://fonts.googleapis.com/css?family=Noto Sans' rel='stylesheet'>
  <app-language-selection *ngIf="displayLanguageSelectionPopup" ></app-language-selection>
  <div class="container py-5">
    <div class="row d-flex justify-content-center my-4">
      <div class="col-md-8">
        <div class="card mb-4">
          <div class="card-header py-3">
            <div class="productInfo">
              <div class="text"><a><img class="bayerLogo" src="assets/logo_bayer.svg" alt="logo" />Bayer</a></div>
              <div (click)="showLanguageSelectionPopup()" class="language-selection">
                  <img src="../../assets/icon_language.svg" alt="" class="translate-icon">
                  <span class="selected-language">{{selectedLanguage }}</span>
                  <img src="../../assets/ic_dropdown.svg" class="drop-down-icon">
              </div>

              <div class="clear"></div>
            </div>

            <div class="dividerLine">
              <hr>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 col-md-12 mb-4 mb-lg-0">
                <div class="bg-image hover-overlay hover-zoom ripple rounded text-center" data-mdb-ripple-color="light">
                  <div>
                    <img style="height: 120px; width: 120px; object-fit: contain;  margin-left: auto;
                       margin-right: auto; padding: 16px;
                       margin-top: 16px;
                       display: block;" src={{productImage}} alt="" />
                  </div>
                  <a href="#!">
                    <div class="mask" style="background-color: rgba(251, 251, 251, 0.2)"></div>
                  </a>
                </div>
              </div>
              <div class="col-lg-5 col-md-6 mb-4 mb-lg-0">
                <a class="productName"><strong>{{productName}}</strong></a>
                <a class="packSize">{{packSize }} {{ 'translateStrings.' + packSizeUnit | translate }}</a>
                <div style="margin-top: 16px;">
                  <a *ngIf="isManufacturingDateAvailable" class="productDetails">
                    {{ 'translateStrings.' + productType | translate }}: {{mfgDate}}</a>
                  <a *ngIf="isExpiryDateAvailable" class="productDetails" style="margin-top: 4px">
                    {{ 'translateStrings.expiry_date' | translate }}: {{expDate}}</a>
                  <a class="productDetails" style="margin-top: 4px">
                    {{ 'translateStrings.product_number_uid' | translate }}: {{uid}}</a>
                  <a class="productDetails" style="margin-top: 4px">
                    {{ 'translateStrings.batch_no' | translate }}: {{batchNo}}</a>
                  <a *ngIf="isPwmRegNumAvailable" class="productDetails" style="margin-top: 4px">
                    {{pwmRegNum}}</a>
                </div>
                <a *ngIf="isLabelDetailsAvailable" href="javascript:void(0);" onclick="window.open">
                  <div class="productInfo" style="margin-top: 20px;" (click)="showLabelDetails()">
                    <div class="text"><strong>{{ 'translateStrings.label_details' | translate }}:</strong></div>
                    <img src="assets/right_arrow.svg" />
                    <div class="clear"></div>
                  </div>
                </a>

                <a *ngIf="isDirectionsAvailable" href="javascript:void(0);" onclick="window.open">
                  <div class="productInfo" style="margin-top: 16px;" (click)="showDirectionsForUse()"
                    href="javascript:void(0);" onclick="window.open">
                    <div class="text"><strong>{{ 'translateStrings.directions_for_use' | translate }}:</strong></div>
                    <img src="assets/right_arrow.svg" />
                    <div class="clear"></div>
                  </div>
                </a>

                <a *ngIf="isPackageOfPracticesAvailable" href="javascript:void(0);" onclick="window.open">
                  <div class="productInfo" style="margin-top: 16px;" (click)="showPackageOfPractices()"
                       href="javascript:void(0);" onclick="window.open">
                    <div class="text"><strong>{{ 'translateStrings.package_of_practices' | translate }}:</strong></div>
                    <img src="assets/right_arrow.svg" />
                    <div class="clear"></div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <body style="margin-top:20px;">
          <div class="col-12">
            <a href="javascript:void(0);" onclick="window.open">
              <img class="bannerImages" style="padding-top:12px;
                   box-sizing: border-box;" src="../../assets/english_banner_1.jpg" alt=""
                (click)="openMobileApp('farmrise_banner_1')" />
            </a>
            <a href="javascript:void(0);" onclick="window.open">
              <img class="bannerImages" style="padding-top:10px; padding-bottom: 16px;
              box-sizing: border-box;" src="../../assets/english_banner_2.jpg" alt=""
                (click)="openMobileApp('farmrise_banner_2')" />
            </a>
          </div>
        </body>
      </div>
    </div>
  </div>
  <div class="empty-space"></div>
  <app-app-download-banner></app-app-download-banner>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait..</p>
  </ngx-spinner>
</section>
